import { LegalLayout } from "@/pages/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy">
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">What We Collect</h2>
        <p>
          When you purchase an assessment, book a consultation, or complete our intake form, we
          collect the information you provide: your name, contact details, business name, website,
          marketing context, and any notes you choose to share. Payments are processed by Stripe; we
          do not receive or store your full card details.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">How We Use It</h2>
        <p>
          We use your information to deliver the assessment or consultation you purchased, prepare
          findings and recommendations, communicate with you about your project, and — where you are
          an ongoing client — manage the services described in your proposal or agreement.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">Sharing</h2>
        <p>
          We share information only with service providers that help us operate, such as payment
          processing and scheduling tools, and only as needed to deliver your services. We do not sell
          your personal information.
        </p>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold text-white mb-3">Retention &amp; Your Choices</h2>
        <p>
          We keep records as long as needed to provide services and meet legal or accounting
          obligations. You may request access to, correction of, or deletion of your personal
          information by contacting us through the options on allinhandmarketing.com.
        </p>
      </div>
      <p>
        Nothing in this policy limits rights that cannot legally be waived under applicable
        consumer-protection law. Privacy questions:{" "}
        <a href="mailto:allinhand@zohomail.com" data-testid="privacy-contact-email" className="text-gold underline underline-offset-2">
          allinhand@zohomail.com
        </a>
        .
      </p>
    </LegalLayout>
  );
}
